import { render, staticRenderFns } from "./videoBanner.vue?vue&type=template&id=23672a47&scoped=true&"
import script from "./videoBanner.vue?vue&type=script&lang=js&"
export * from "./videoBanner.vue?vue&type=script&lang=js&"
import style0 from "./videoBanner.vue?vue&type=style&index=0&id=23672a47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23672a47",
  null
  
)

export default component.exports